import { z } from 'zod';
import { AppointmentStatus, Priority } from '../enums.js';
import { paginationQuerySchema } from '../pagination.js';
import { optionalString, optionalId, optionalInt } from './common.js';
/** Création d'un rendez-vous. */
export const createAppointmentSchema = z.object({
    customerId: z.string().min(1, 'Client requis'),
    vehicleId: z.string().min(1, 'Véhicule requis'),
    mechanicId: optionalId(),
    reason: z.string().trim().min(1, 'Motif requis').max(200),
    scheduledAt: z.coerce.date({ errorMap: () => ({ message: 'Date/heure invalide' }) }),
    estimatedDurationMin: optionalInt({ min: 5, max: 1440 }),
    priority: z.nativeEnum(Priority).default(Priority.NORMAL),
    status: z.nativeEnum(AppointmentStatus).default(AppointmentStatus.PENDING),
    notes: optionalString(2000),
});
/** Mise à jour : tous les champs optionnels. */
export const updateAppointmentSchema = createAppointmentSchema.partial();
/** Changement de statut isolé. */
export const updateAppointmentStatusSchema = z.object({
    status: z.nativeEnum(AppointmentStatus),
});
/** Filtres de liste / calendrier. */
export const appointmentsQuerySchema = paginationQuerySchema.extend({
    // Le calendrier charge une plage entière : on autorise une page plus large.
    pageSize: z.coerce.number().int().min(1).max(1000).default(100),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
    status: z.nativeEnum(AppointmentStatus).optional(),
    mechanicId: z.string().optional(),
    customerId: z.string().optional(),
    vehicleId: z.string().optional(),
});
//# sourceMappingURL=appointment.js.map